import React from "react";

import "@include/syncfusion-bootstrap4-base.css";
import "@include/syncfusion-bootstrap4-grids.css";

import PageLayout from "@layout/PageLayout";

import DistrictPlansBody from "./DistrictPlansBody";
import { transformDistrictPlansPageData } from "./transformDistrictPlansPageData";
import {
	renderRichText,
	bulkRenderRichText,
} from "@utils/prismic-render-utils";

const renderCurrentDistrictsRichText = currentDistricts => {
	return {
		mainBodyText: renderRichText(currentDistricts.mainBodyText),
		groups: currentDistricts.groups
			? currentDistricts.groups.map(group => ({
					...group,
					...bulkRenderRichText(group, ["id", "docs"]),
			  }))
			: [],
	};
};

const renderProposalsRichText = proposedDistricts => {
	const renderedProposals = {};
	const mainBodyText = renderRichText(proposedDistricts.mainBodyText);

	if (proposedDistricts.proposals) {
		Object.keys(proposedDistricts.proposals).map(key => {
			const proposal = proposedDistricts.proposals[key];

			if (proposal.type == "group") {
				const proposalTextFields = bulkRenderRichText(proposal, [
					"titlePlainText",
					"billLink",
					"overviewMaps",
					"proposals",
					"type",
				]);
				const overviewMaps = proposal.overviewMaps.map(m =>
					bulkRenderRichText(m, [""])
				);
				const proposals = proposal.proposals.map(p => ({
					...p,
					title: renderRichText(p.title),
					mapGroups: p.mapGroups.map(group => ({
						...group,
						title: renderRichText(group.title),
					})),
				}));
				renderedProposals[key] = {
					...proposal,
					...proposalTextFields,
					overviewMaps: overviewMaps,
					proposals: proposals,
				};
				return;
			}
			renderedProposals[key] = {
				...proposal,
				body: renderRichText(proposal.body),
			};
		});
	}
	return { mainBodyText: mainBodyText, proposals: renderedProposals };
};

const renderRichTextFields = data => ({
	...data,
	currentDistricts: renderCurrentDistrictsRichText(data.currentDistricts),
	finalDistricts: renderCurrentDistrictsRichText(data.finalDistricts),
	legislativeProposals: renderProposalsRichText(data.legislativeProposals),
	publicProposals: renderProposalsRichText(data.publicProposals),
});

const DistrictPlans = props => {
	const data = props.previewData
		? renderRichTextFields(
				transformDistrictPlansPageData(props.previewData)
		  )
		: renderRichTextFields(props.pageContext.data);

	return (
		<PageLayout
			{...props}
			data={data}
			tocQuery="h2,h3"
			pageTitle="District Plans"
			renderPage={pageProps => <DistrictPlansBody {...pageProps} />}
		/>
	);
};

export default DistrictPlans;
